<template>
  <div class="wrapper-app">
    <router-view :key="$route.fullPath" />
    <loader/>
  </div>
</template>

<script>


import Loader from './components/Loader.vue';

export default {
  name: 'app',
  components: {
    Loader
  },
  data() {
    return {
    }
  },
  computed:{
    isAuthenticated:function(){
      console.log('this.$store.getters.isAuthenticated',this.$store.getters.isAuthenticated);
      return this.$store.getters.isAuthenticated
    }
  },
  methods:{


  },
  mounted(){

  }

}



</script>

<style>

</style>
